import { TableDataServiceObjectInterface } from '@components/components/table/table.interface';
import { Component, Input, Output, EventEmitter } from '@angular/core';

import { TableHeadInterface } from '../../table.interface';

@Component({
  selector: 'sp-table-head',
  standalone: false,
  templateUrl: './table-head.component.html',
  styleUrls: ['./table-head.component.scss']

})
export class TableHeadComponent implements TableHeadInterface {
  @Input() header = [];
  @Input() query = {};
  @Input() dateQuery = {};
  @Input() basicQuery = {};
  @Input() withCheckbox: boolean;
  @Input() doubleClickToCheck: boolean = false;
  @Input() DataService: TableDataServiceObjectInterface = {
    fetch: fieldname => {},
    create: formData => {},
    update: (id, formData) => {}
  };
  @Output() propagateChecked = new EventEmitter<boolean>();
  @Input() headerCheck: boolean;
  sortOptions = ['default', 'ASC', 'DESC'];
  sortIcons = {
    default: '/public/resources/images/icons/sorting-disabled.svg',
    ASC: '/public/resources/images/icons/sorting-up.svg',
    DESC: '/public/resources/images/icons/sorting-down.svg'
  };
  checkedBoxes = false;
  setSort(th) {
    const currentIndex = this.sortOptions.indexOf(th.sort);
    let nextIndex = currentIndex;

    if (currentIndex === this.sortOptions.length - 1) {
      nextIndex = 0;
    } else {
      nextIndex = currentIndex + 1;
    }

    th.sort = this.sortOptions[nextIndex];

    if ('fetch' in this.DataService) {
      // call sort fetch action
      this.DataService.fetch(`${th.sort}|${th.fieldName}`);
    }
  }

  onToggleHeaderCheckbox(event) {
    this.propagateChecked.emit(event.target.checked);
  }

  toggleHeaderCheckBox() {
    console.log('toggled');
    if (!this.withCheckbox) {
      return;
    }
    this.checkedBoxes = !this.checkedBoxes;
    this.propagateChecked.emit(this.checkedBoxes);
  }

  constructor() {}
}